import { AuditableRowModel } from '../../Forms/models/auditable-row.model';
import { BriefingListItemModel } from './briefing-list-item.model';
import { DistributionSummaryModel } from '../../TargetingShared/model/distribution-summary-model';
import { BriefingDeliveryMethodEnum } from '../../../Monitor/Briefings/enums/briefing-delivery-method.enum';

export enum TemplateRowType {
    EMAIL_BRIEFING = 'Email Briefing',
    DISTRIBUTION = 'Distribution',
    CANVAS_BRIEFING = 'Canvas Briefing'
}

export class TemplateRowModel extends AuditableRowModel {

    template: BriefingListItemModel | DistributionSummaryModel;
    type: TemplateRowType;
    tooltipInfo: string;

    constructor(template: BriefingListItemModel | DistributionSummaryModel) {
        super();

        if (template instanceof BriefingListItemModel) {

            this.type = template.deliveryMethod === BriefingDeliveryMethodEnum.ONLINE
                ? TemplateRowType.CANVAS_BRIEFING : TemplateRowType.EMAIL_BRIEFING;
        } else if (template instanceof DistributionSummaryModel) {
            this.type = TemplateRowType.DISTRIBUTION;
        }

        this.name = template.name;
        this.template = template;

        this.createdDate = new Date(template.createdDate);
        this.createdByUser = template.createdByUserId;

        this.modifiedByUser = template.modifiedByUserId;
        this.modifiedDate = new Date(template.modifiedDate);
    }
}
